import styled from "@emotion/styled";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

export const StyledActionWrapper = styled(FlexCenter)`
  cursor: pointer;
`;
